import CompanyProfileContainer from "../../Components/CompanyProfile";
import { useEffect } from "react";
import RoleGuard from "../RoleGuard";
import { useAppSelector } from "../../ReduxToolkit/Hooks";

const CompanyProfile = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Client Profile";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer"]}
      />

      {/* Main content */}
      <CompanyProfileContainer />
    </>
  );
};

export default CompanyProfile;
